import React from 'react'
import { Box, Typography } from '@mui/material'
import CampaignIcon from 'components/material-symbol/icons/Campaign'

const CampaignMessageLabel = () => (
  <Box
    data-testid="campaign-message-label"
    sx={{
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: 0.5,
      px: 2,
      mt: 1,
      color: 'text.secondary',
    }}
  >
    <CampaignIcon style={{ fontSize: 14 }} />
    <Typography variant="caption" sx={{ fontWeight: 600 }}>
      Campaign
    </Typography>
  </Box>
)

export default CampaignMessageLabel
